module.exports = __webpack_public_path__ + "media/hph-24-09_academic-excellence.545a736b.mp4";